var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-icon/check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5007 37.1663C29.7054 37.1663 37.1673 29.7044 37.1673 20.4997C37.1673 11.2949 29.7054 3.83301 20.5007 3.83301C11.2959 3.83301 3.83398 11.2949 3.83398 20.4997C3.83398 29.7044 11.2959 37.1663 20.5007 37.1663Z",
    fill: "#00A962",
    stroke: "#00A962",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5 20.5003L18.8333 23.8337L25.5 17.167",
    stroke: "#FCFFFD",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenWhite);
export default __webpack_public_path__ + "static/media/check-green-white.bd654179fe24cfb395574238902609f5.svg";
export { ForwardRef as ReactComponent };